import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminFaqList from "../../../../views/admin/cms/faqs/AdminFaqList";

const AdminFaqPageList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminFaqList />
      <AdminFooter />
    </div>
  );
};

export default AdminFaqPageList;
